import { Button, Form, Card } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import {useRef, useState} from "react";
import ReCAPTCHA from "react-google-recaptcha"
import './Contact.css';

export default function Contact() {

    const form = useRef();
    const captchaRef = useRef(null);
    const [sent, setSent] = useState(false);
    const [formValue, setFormValue] = useState({
        from_name: "",
        from_email: "",
        message: "",
      });

    function handleSubmit (e) {
        e.preventDefault();

        const token = captchaRef.current.getValue();

        const params = {
            ...formValue,
            "g-recaptcha-response": token
        };

        emailjs.send(
            'service_37npnhv',
            'template_qn3dg54',
            params,
            {publicKey: '508fdRpZRh6QdXfjg'}
          )
          .then(
            (response) => {
              setSent(true);
              captchaRef.current.reset();
            },
            (error) => {
              console.log(error.text);
            }
          );
      }

    return (
        <>
            <div className="contactPage">
                <div className="contactContainer">
                    <h1 className="contactTitle">Send A Message</h1>
                        {sent ? <div className="contactSuccessMessage">
                            <p>Your message has been sent! We'll get back to you ASAP.</p>
                            </div> :
                            <div className="contactFormContainer">
                                <Form ref={form} id="form" className="contactFormGroup" onSubmit={handleSubmit}>
                                    <Form.Group className="contactInput">
                                        <Form.Control
                                            id="name" 
                                            name="name" 
                                            type="text" 
                                            placeholder="Name" 
                                            value={formValue.user_name}
                                            required 
                                            onChange={(e) => setFormValue({ ...formValue, from_name: e.target.value })}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group className="contactInput">
                                        <Form.Control
                                            id="email" 
                                            name="email" 
                                            type="email" 
                                            placeholder="Email" 
                                            value={formValue.user_email}
                                            required 
                                            onChange={(e) => setFormValue({ ...formValue, from_email: e.target.value })}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group className="contacttextarea">
                                        <Form.Control
                                            as="textarea"
                                            id="message"
                                            name="message"
                                            placeholder="Message"
                                            value={formValue.message}
                                            required
                                            onChange={(e) => setFormValue({ ...formValue, message: e.target.value })}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                    <ReCAPTCHA 
                                        sitekey="6LelyFwqAAAAAHFffAx5R8ealNDxgb3HTmuIpe5_"
                                        ref={captchaRef}
                                    />
                                    <Button className="contactButton" variant="dark" size="lg" type="submit">Submit</Button>
                                </Form>
                            </div>
                        }
                </div>
            </div>
        </>
    );
}